import axios from 'axios'

/**
  @Gowtham 
   - axios-setup=> setting up default config for every request  
 */
const UseAxios = axios.create({
  baseURL: import.meta.env.REACT_APP_BASE_URL_DEV,
  headers: {
    Accept: 'application/json',
  },
})

export default UseAxios
